import { DashboardEconomyChangeCategory } from '@interfaces/dashboard/responses/dashboard-economy-changes.response';

/** Rótulo de cada item da divisão da variação (card 3295). */
export const ECONOMY_CHANGE_CATEGORY_LABELS: Record<DashboardEconomyChangeCategory, string> = {
  Benchmark: 'Benchmark trocado',
  LoansEntered: 'Operações que entraram',
  LoansLeft: 'Operações que saíram',
  Amendments: 'Aditamentos',
  LoanChanges: 'Operações e derivativos alterados',
  Market: 'Mercado e demais',
  Rules: 'Regra da economia atualizada',
};

/** Explicação curta de cada item, exibida abaixo do rótulo. */
export const ECONOMY_CHANGE_CATEGORY_HINTS: Record<DashboardEconomyChangeCategory, string> = {
  Benchmark: 'Efeito da troca do benchmark da empresa.',
  LoansEntered:
    'Economia das operações que passaram a contar no período (novas ou devolvidas à economia).',
  LoansLeft:
    'Economia das operações que deixaram de contar (excluídas, tiradas da economia ou fora da regra).',
  Amendments: 'Efeito dos aditamentos nas operações aditadas.',
  LoanChanges: 'Cadastro, parcelas, liquidação ou derivativos das operações alteradas.',
  Market:
    'CDI e curvas nas rodadas diárias. Na Prevista Inicial só muda com evento, porque cada operação usa o DI da primeira foto.',
  Rules:
    'Ajuste de regra da plataforma: SWAP e NDF Vanilla entram e o DI fica o da primeira foto de cada operação.',
};

/** Ordem de exibição das categorias. */
export const ECONOMY_CHANGE_CATEGORY_ORDER: DashboardEconomyChangeCategory[] = [
  'Rules',
  'Benchmark',
  'LoansEntered',
  'LoansLeft',
  'Amendments',
  'LoanChanges',
  'Market',
];

/** Rótulo do motivo de cada versão do histórico (`DashboardEconomyScenarioTrigger`). */
export const ECONOMY_TRIGGER_LABELS: Record<string, string> = {
  Unknown: 'Sem motivo registrado',
  Scheduled: 'Rotina diária',
  Missing: 'Primeira geração',
  Stale: 'Atualização do dia',
  ManualReprocess: 'Reprocesso manual',
  BenchmarkChanged: 'Benchmark trocado',
  LoanCreated: 'Operação criada',
  LoanChanged: 'Operação alterada',
  LoanDeleted: 'Operação excluída',
  LoanAmended: 'Aditamento',
  DerivativesChanged: 'Derivativo alterado',
  LoanExcluded: 'Operação tirada da economia',
  LoanIncluded: 'Operação devolvida à economia',
  RulesUpdated: 'Regra da economia atualizada',
};

/** Motivos de rodada automática (sem evento): o filtro "só eventos" esconde estes. */
export const ECONOMY_AUTOMATIC_TRIGGERS = new Set(['Scheduled', 'Stale', 'Missing', 'Unknown']);

export function economyTriggerLabel(trigger: string | null | undefined): string {
  return (trigger && ECONOMY_TRIGGER_LABELS[trigger]) || trigger || '';
}

export function isAutomaticEconomyTrigger(trigger: string | null | undefined): boolean {
  return !trigger || ECONOMY_AUTOMATIC_TRIGGERS.has(trigger);
}

/** Régua exibida: Prevista Inicial (contratual) ou Prevista até Final (fluxo de caixa). */
export type EconomyMeasure = 'inicial' | 'atual';
